SITE.Gtm = {

    /**
     * Set GTM Event
     * --------------
     * @param  {string} eventName Name of Event, no spaces
     * @return {boolean}           Success or not
     */
    event: function(eventName) {
        "use strict";

        window.dataLayer = window.dataLayer || []; 
        return dataLayer.push({'event': eventName});

    }
};